/* 🤖 this file was generated by svg-to-ts */
export const matIconSettingsPower: {
  name: 'settings-power';
  data: string;
} = {
  name: 'settings-power',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44-1.45 1.45A5.969 5.969 0 0 1 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 0 0 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"/></svg>`
};
